/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{VertexAttribute as e}from"./VertexAttribute.js";import{DataType as r}from"../../../webgl/enums.js";import{VertexElementDescriptor as t}from"../../../webgl/VertexElementDescriptor.js";const O=[],o=[new t(e.POSITION,3,r.FLOAT,0,12)],m=[new t(e.POSITION,2,r.FLOAT,0,8)],n=[new t(e.POSITION,2,r.FLOAT,0,16),new t(e.UV0,2,r.FLOAT,8,16)];export{O as NoVertex,m as Pos2,n as Pos2Tex,o as Pos3};
